import type { ProductCodeAttributeType } from "~/shared/attributes/product-code-attribute-type.constants";

import { MultiSelect, type MultiSelectProps, Select, type SelectItem, type SelectProps } from "~/ui";
import { api } from "~/utils/api";

type ProductCodeAttributeSelectProps = Omit<SelectProps, "data"> & {
  attributeTypes?: readonly ProductCodeAttributeType[];
};

type ProductCodeAttributeMultiSelectProps = Omit<MultiSelectProps, "data"> & {
  attributeTypes?: readonly ProductCodeAttributeType[];
};

function useGetProductCodeAttributeData(attributeTypes?: readonly ProductCodeAttributeType[]): SelectItem[] {
  const { data } = api.products.getManyProductCodeAttribute.useQuery();
  const items = data ?? [];
  const allowedTypes = attributeTypes != null && attributeTypes.length > 0 ? new Set<string>(attributeTypes) : null;
  const filtered = allowedTypes != null ? items.filter(item => allowedTypes.has(item.type)) : items;
  return filtered.map(d => ({ value: d.id, label: d.name }));
}

export const ProductCodeAttributeSelect = ({ attributeTypes, ...props }: ProductCodeAttributeSelectProps) => {
  const data = useGetProductCodeAttributeData(attributeTypes);
  return <Select {...props} data={data} />;
};

export const ProductCodeAttributeMultiSelect = ({ attributeTypes, ...props }: ProductCodeAttributeMultiSelectProps) => {
  const data = useGetProductCodeAttributeData(attributeTypes);
  return <MultiSelect {...props} data={data} />;
};
